import { render, staticRenderFns } from "./Declarations.vue?vue&type=template&id=99a0e5d0&"
import script from "./Declarations.vue?vue&type=script&lang=js&"
export * from "./Declarations.vue?vue&type=script&lang=js&"
import style0 from "./Declarations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports